import React from 'react';
import {SSRDataContext} from '../SSRDataContext';

export const withSSRData = Component => {
    return function WithSSRData(props) {
        return (
            <SSRDataContext.Consumer>
                {ssrData => <Component {...props} ssrData={ssrData} />}
            </SSRDataContext.Consumer>
        );
    };
};
